import { createFileRoute, redirect } from '@tanstack/react-router';

// DA-156: Redirect old /substitute/applications route to /substitute/services
export const Route = createFileRoute('/_protected/substitute/applications')({
  beforeLoad: () => {
    throw redirect({
      to: '/substitute/services',
      replace: true,
    });
  },
});
